import { ref, watch, computed } from 'vue'

export function useDualRangeSlider(props, emit) {
  // 1) lokální kopie
  const init = Array.isArray(props.modelValue) && props.modelValue.length === 2
      ? [
          Math.max(props.min, Math.min(props.max, props.modelValue[0] ?? props.min)),
          Math.max(props.min, Math.min(props.max, props.modelValue[1] ?? props.max))
        ]
      : [ props.min, props.max ]
  const local = ref([ ...init ])

  // 2) kdykoliv rodič změní hodnotu, aktualizuj
  watch(() => props.modelValue, nv => {
    if (Array.isArray(nv) && nv.length === 2) {
      local.value = [
        Math.max(props.min, Math.min(props.max, nv[0] ?? props.min)),
        Math.max(props.min, Math.min(props.max, nv[1] ?? props.max))
      ]
    } else {
      local.value = [ props.min, props.max ]
    }
  }, { immediate: true })

  // 3) nedovol, aby se roučky překřížily nebo byly příliš blízko
  function onInput(handle) {
    const [low, high] = local.value

    // Ensure the values are within bounds first
    if (low < props.min) local.value[0] = props.min
    if (high > props.max) local.value[1] = props.max

    // Ensure minimum separation of at least one step
    if (handle === 'lower') {
      // If lower thumb is being moved
      const maxLowerValue = local.value[1] - props.step
      if (local.value[0] > maxLowerValue) {
        local.value[0] = maxLowerValue
      }
    } else if (handle === 'upper') {
      // If upper thumb is being moved
      const minUpperValue = local.value[0] + props.step
      if (local.value[1] < minUpperValue) {
        local.value[1] = minUpperValue
      }
    }
  }

  // 4) emitni ven po změně
  function emitChange() {
    onInput('lower')
    onInput('upper')
    // Ensure values are constrained before emitting
    const constrainedValues = [
      Math.max(props.min, Math.min(props.max, local.value[0])),
      Math.max(props.min, Math.min(props.max, local.value[1]))
    ]
    emit('update:modelValue', constrainedValues)
  }

  // 5) styl pro vybraný úsek
  const selectedTrackStyle = computed(() => {
    const total = props.max - props.min
    // Ensure values are constrained within min and max
    const l = Math.max(props.min, Math.min(props.max, local.value[0]))
    const h = Math.max(props.min, Math.min(props.max, local.value[1]))
    return {
      left:  `${(l - props.min) / total * 100}%`,
      width: `${(h - l)       / total * 100}%`,
    }
  })

  return {
    local,
    onInput,
    emitChange,
    selectedTrackStyle
  }
}